<script setup>
import {
  Empty,
  EmptyHeader,
  EmptyTitle,
  EmptyDescription,
  EmptyContent,
} from 'next/polaris/ui/empty';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { onMounted } from 'vue';

const toggleSupportWidgetVisibility = () => {
  if (window.$chatwoot) {
    window.$chatwoot.toggleBubbleVisibility('show');
  }
};

const toggleSupportWidget = () => {
  if (window.$chatwoot) {
    window.$chatwoot.toggle();
  }
};

const setupListenerForWidgetEvent = () => {
  window.addEventListener('chatwoot:on-message', () => {
    toggleSupportWidgetVisibility();
  });
};

onMounted(() => {
  toggleSupportWidgetVisibility();
  setupListenerForWidgetEvent();
});
</script>

<template>
  <div
    class="flex items-center justify-center h-full w-full bg-polaris-background text-polaris-foreground"
  >
    <Empty>
      <EmptyHeader>
        <EmptyTitle>{{ $t('APP_GLOBAL.ACCOUNT_SUSPENDED.TITLE') }}</EmptyTitle>
        <EmptyDescription>
          {{ $t('APP_GLOBAL.ACCOUNT_SUSPENDED.MESSAGE') }}
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <NextButton
          icon="i-lucide-life-buoy"
          :label="$t('SIDEBAR_ITEMS.CONTACT_SUPPORT')"
          @click="toggleSupportWidget"
        />
      </EmptyContent>
    </Empty>
  </div>
</template>
